import { extendTheme } from "@chakra-ui/react";

import '@fontsource-variable/inter';

import colors from "./foundations/colors";
import fontSizes from "./foundations/fontSizes";
import styles from "./styles";

/**
 * This file is generated for providing a custom theme to Chakra UI
 *
 * To learn more about custom themes
 * please visit https://chakra-ui.com/docs/getting-started#add-custom-theme-optional
 */

const overrides = {
  ...styles,
  colors,
  fontSizes,
//   fonts: {
//     heading: "Poppins, sans-serif",
//     body: "Poppins, sans-serif",
//   },
fonts: {
    heading: "'Inter Variable', sans-serif",
    body: "'Inter Variable', sans-serif",
  },
};

const theme = extendTheme(overrides);

export default theme;
